<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Số điện thoại
        </label>
        <b-input v-model="entry.phone" type="text" placeholder="Nhập số điện thoại..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            phone: "",
        },
    }),
    watch: {
        "entry.phone": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    phone: this.entry.phone,
                });
            },
            deep: true,
        },
        "value.phone": {
            handler: function () {
                this.entry.phone = this.value.phone;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>